export const companyTabsTypes = {
  awards: 'awards',
  benefits: 'benefits',
  chat: 'chat',
  general: 'general',
  jobs: 'jobs',
  offices: 'offices',
  recruitment: 'recruitment'
}
